export default "__VITE_ASSET__DKhdedEi__"